import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import "./tableSection.scss";

interface ITableSectionProps extends ComponentPropsWithoutRef<"div"> { }

export const TableSection = (props: ITableSectionProps) => {
    return <div {...props} className={clsx("table-section", props.className)} />;
};
